<template>
    <div class="el-material-expand">
        <el-row>
            <el-col :span="6">
                <div class="el-plateNo-wrapper">
                    <v-text-field
                        :label="$t('form.label.plateNo')"
                        :readonly="readonly"
                        v-model="notification.PlateNo"
                    ></v-text-field>
                </div>
            </el-col>
            <el-col :span="6">
                <div
                    v-if="isBlc && 'CREATED' === notification.StatusDescription"
                    class="el-arrival-wrapper"
                >
                    <el-date-picker
                        id="actualArrival"
                        @change="setArrival"
                        v-model="notification.ActualArrival"
                        type="datetime"
                        format="yyyy-MM-dd HH:mm"
                        :placeholder="$t('form.label.arrival')"
                        :picker-options="pickerOptions"
                        class="el-date-picker-dark el-date-picker-dark--lg"
                    >
                    </el-date-picker>
                    <v-btn
                        class="
                            el-table-info__btn
                            el-btn-with-input
                            el-table-info__btn--dark
                        "
                        flat
                        @click="setArrival"
                    >
                        {{ $t('button.text.arrivedToBlc') }}
                    </v-btn>
                </div>
                <div v-else class="el-plateNo-wrapper">
                    <v-text-field
                        :label="$t('form.label.arrivedToBlc')"
                        readonly
                        v-model="notification.actualArrival"
                    ></v-text-field>
                </div>
            </el-col>
            <el-col :span="6" v-if="showExtraFields">
                <el-date-picker
                    v-if="'CREATED' === notification.StatusDescription"
                    id="estimatedArrival"
                    v-model="notification.EstimatedArrival"
                    type="datetime"
                    format="yyyy-MM-dd HH:mm"
                    placeholder="Estimated Arrival"
                    :picker-options="pickerOptions"
                    class="
                        el-date-picker-dark el-date-picker-dark--lg
                        el-datepicker-wrapper
                    "
                >
                </el-date-picker>
                <div v-else class="el-plateNo-wrapper">
                    <v-text-field
                        :label="$t('form.label.estimatedArrival')"
                        readonly
                        v-model="notification.estimatedArrival"
                    ></v-text-field>
                </div>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="6" v-if="showExtraFields">
                <stc-password
                    v-if="'CREATED' === notification.StatusDescription"
                    :labelText="$t('form.label.pinCodeForDriver')"
                    class="el-text-field-wrapper"
                    readonly
                    v-model="notification.PinCode"
                    fetch-url="Util/GeneratePin"
                >
                </stc-password>
                <div v-else class="el-plateNo-wrapper">
                    <v-text-field
                        :label="$t('form.label.pinCodeForDriver')"
                        readonly
                        v-model="notification.PinCode"
                    ></v-text-field>
                </div>
            </el-col>
            <el-col :span="6" v-if="showExtraFields">
                <v-text-field
                    label="Email"
                    class="el-text-field-wrapper"
                    :readonly="readonly"
                    v-model="notification.Email"
                ></v-text-field>
            </el-col>
            <el-col :span="6" v-if="showExtraFields">
                <v-text-field
                    label="Phone"
                    class="el-text-field-wrapper"
                    :readonly="readonly"
                    v-model="notification.Phone"
                ></v-text-field>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
                <h2
                    class="el-form-card__inner-title mb-2"
                    v-html="$t('form.title.unloadingResourcesAtBLC')"
                />
                <div class="el-inner-table-check-box-list">
                    <div class="dark-form">
                        <div class="el-radio-list">
                            <v-checkbox
                                :label="$t('form.label.forkLift')"
                                :disabled="readonly"
                                class="booking__check-box--fork-lift"
                                v-model="notification.RequestedResources"
                                color="success"
                                value="FORKLIFT"
                                hide-details
                            >
                            </v-checkbox>

                            <v-checkbox
                                :label="$t('form.label.truck')"
                                :disabled="readonly"
                                class="booking__check-box--truck"
                                v-model="notification.RequestedResources"
                                color="success"
                                value="TRUCK"
                                hide-details
                            >
                            </v-checkbox>

                            <v-checkbox
                                :label="$t('form.label.labourers')"
                                :disabled="readonly"
                                class="booking__check-box--labourers"
                                v-model="notification.RequestedResources"
                                color="success"
                                value="MANPOWER"
                                hide-details
                            >
                            </v-checkbox>
                        </div>
                    </div>
                </div>
                <div class="el-inner-table-check-box-list">
                    <div class="dark-form">
                        <div class="el-radio-list">
                            <v-checkbox
                                :label="$t('form.label.industrialCrane')"
                                :disabled="readonly"
                                class="booking__check-box--crane"
                                v-model="notification.RequestedResources"
                                color="success"
                                value="CRANE"
                                hide-details
                            >
                            </v-checkbox>

                            <v-checkbox
                                :label="$t('form.label.tools')"
                                :disabled="readonly"
                                class="booking__check-box--tools"
                                v-model="notification.RequestedResources"
                                color="success"
                                value="TOOLS"
                                hide-details
                            >
                            </v-checkbox>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :span="12" v-if="showExtraFields">
                <div
                    class="
                        el-checkbox-list
                        booking__check-box--express-delivery
                    "
                >
                    <div class="dark-form">
                        <div class="el-radio-list">
                            <v-checkbox
                                :label="$t('form.label.expressDelivery')"
                                v-model="notification.IsExpress"
                                :disabled="readonly"
                                color="success"
                                hide-details
                            >
                            </v-checkbox>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>

        <stc-blc-package
            v-for="blcPackage in allPackageGroups"
            :key="blcPackage.PackageGroupID"
            :notification="notification"
            :readonly="readonly && blcPackage.StatusDescription !== 'CREATED'"
            :show-extra-fields="showExtraFields"
            :data-blc-package="blcPackage"
            :suppliers="suppliers"
            :isInventory="isInventory"
            @delete-blc-package="deletePackage"
            @remove-blc-package="removePackage"
            @item-update="$emit('item-update', $event)"
            @item-create="$emit('item-create', $event)"
            @item-delete="$emit('item-delete', $event)"
            @package-update="$emit('package-update', $event)"
            @package-create="$emit('package-create', $event)"
            @package-delete="$emit('package-delete', $event)"
            @item-move-to-store="$emit('item-move-to-store', $event)"
            @notification-update="$emit('notification-update', $event)"
        >
        </stc-blc-package>

        <div v-if="!readonly" class="el-row">
            <div class="el-bottom-btn-panel">
                <v-btn
                    class="
                        el-table-info__btn
                        el-table-info__btn--lg
                        el-table-info__btn--primary
                    "
                    flat
                    @click="addPackage"
                >
                    {{ $t('modal.button.addPackageGroup') }}
                </v-btn>
                <v-btn
                    class="
                        el-table-info__btn
                        el-table-info__btn--sm
                        el-table-info__btn--primary
                    "
                    v-if="false"
                    @click="$emit('notification-to-stock', notification)"
                    flat
                >
                    {{ $t('button.text.storeStock') }}
                </v-btn>
                <v-btn
                    class="
                        el-table-info__btn
                        el-table-info__btn--sm
                        el-table-info__btn--warning
                    "
                    flat
                    @click="$emit('delete-notification', notification)"
                >
                    {{ $t('button.text.delete') }}
                </v-btn>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import { DateTime } from 'luxon'
import { mapGetters } from 'vuex'
import StcBlcPackage from './BlcPackage'
import StcPassword from '../../Password'
import InteractWithBlc from '../../../mixins/interact-with-blc'
import InteractWithActor from '../../../mixins/interact-with-actor'

export default {
    name: 'blc-notification',

    props: {
        dataNotification: {
            type: Object,
            required: true,
        },
        readonly: {
            type: Boolean,
            required: true,
        },
        showExtraFields: {
            default: false,
            type: Boolean,
        },
        suppliers: {
            type: Array,
            required: true,
        },
        isInventory: false,
    },

    components: {
        'stc-password': StcPassword,
        'stc-blc-package': StcBlcPackage,
    },

    mixins: [InteractWithBlc, InteractWithActor],

    data() {
        let notification = _.cloneDeep(this.dataNotification)
        let packageGroups = _.cloneDeep(this.dataNotification.PackageGroups)
        if (!this.isInventory) {
            packageGroups = packageGroups.filter((group) =>
                group.PackageItems.some(
                    (item) =>
                        item.StatusDescription !== 'HIDDEN_INVENTORY_TO_STOCK'
                )
            )
        }

        notification.PinCode = ''
        notification.Email = ''
        notification.Phone = ''
        notification.EstimatedArrival = DateTime.fromISO(
            notification.EstimatedArrival
        ).toJSDate()

        if (notification.ActualArrival) {
            notification.ActualArrival = DateTime.fromISO(
                notification.ActualArrival
            ).toJSDate()
        }

        return {
            notification,
            packageGroups,
        }
    },

    created() {
        this.fillExtraFields()
    },

    watch: {
        notification: {
            handler: _.debounce(function (newVal) {
                this.updateNotification(newVal)
            }, 500),
            deep: true,
        },
    },

    computed: {
        ...mapGetters(['isBlc', 'selectedContainer']),

        pickerOptions() {
            return {
                firstDayOfWeek: 1,
            }
        },

        container() {
            return this.isBlc ? this.selectedContainer : this.containerBlcData
        },

        allPackageGroups() {
            let actorPackageGroups = _(this.dataNotification.Actors)
                .flatMap('PackageGroups')
                .value()
            actorPackageGroups.forEach((group) => {
                group.Images = undefined
            })
            // Concat actorPackageGroups and current packageGroups
            let mergedPackagedGroups = _.cloneDeep(
                actorPackageGroups.concat(this.packageGroups)
            )

            // Find duplication package groups in 'mergedPackagedGroups'
            let dups = _.filter(
                _.uniq(
                    _.map(mergedPackagedGroups, function (item) {
                        if (
                            _.filter(mergedPackagedGroups, {
                                PackageGroupID: item.PackageGroupID,
                            }).length > 1
                        ) {
                            return item.PackageGroupID
                        }
                        return false
                    })
                ),
                function (value) {
                    return value
                }
            )
            if (dups && dups.length > 0) {
                dups.forEach((dup) => {
                    // Create new merged package group
                    let finalPacakgeItems = []
                    let finalPackageGroup

                    // Concat package items in matching duplicates
                    mergedPackagedGroups.forEach((packageGroup) => {
                        if (packageGroup.PackageGroupID === dup) {
                            finalPackageGroup = packageGroup
                            finalPacakgeItems.push(...packageGroup.PackageItems)
                        }
                    })
                    // Prepare new merged package group
                    finalPacakgeItems = _.uniqBy(
                        finalPacakgeItems,
                        'PackageItemID'
                    )
                    finalPackageGroup.PackageItems = finalPacakgeItems

                    // Remove existing duplicates from mergedPackagedGroups
                    _.remove(mergedPackagedGroups, function (group) {
                        return group.PackageGroupID === dup
                    })

                    // Add new package group to mergedPackagedGroups
                    mergedPackagedGroups.push(finalPackageGroup)
                })
            }
            return mergedPackagedGroups
        },
    },

    methods: {
        async setArrival(e) {
            try {
                await this.$confirm(
                    this.$i18n.i18next.t('message.warning.statusArrivedToBLC'),
                    'Warning',
                    {
                        confirmButtonText: this.$i18n.i18next.t(
                            'button.text.confirm'
                        ),
                        cancelButtonText:
                            this.$i18n.i18next.t('button.text.cancel'),
                        type: 'warning',
                    }
                )

                if (e instanceof Date) {
                    this.notification.ActualArrival = e.toISOString()
                } else {
                    this.notification.ActualArrival =
                        DateTime.local().toJSDate()
                }
            } catch (e) {
                this.notification.ActualArrival = ''
            }
        },

        addPackage() {
            this.packageGroups.push({
                PackageGroupID: '',
                Reference: '',
                OrderNo: '',
                SupplierName: '',
                SupplierID: '',
                PackageItems: [
                    {
                        Height: 0,
                        Width: 0,
                        Length: 0,
                        Weight: 0,
                        Description: '',
                        TrackingReference: '',
                        CustomReference: '',
                        PackageItemID: '',
                        PackageType: '',
                    },
                ],
                StatusDescription: 'NEW',
            })
        },

        async fillExtraFields() {
            let actor = await this.fetchActorByID(
                this.notification.RelatedActorID
            )

            this.notification.PinCode = actor.PinCode
            this.notification.Email = actor.Email
            this.notification.Phone = actor.Phone
        },

        async updateNotification(notification) {
            let dateTimeFormat = process.env.VUE_APP_DATETIME_FORMAT

            let actualArrival = ''
            if (notification.ActualArrival) {
                actualArrival = DateTime.fromISO(
                    notification.ActualArrival.toISOString()
                ).toFormat(dateTimeFormat)
            }

            await this.$http.put(
                `/BLC/${this.container.ContainerID}/Notification/${this.notification.BLCNotificationID}`,
                {
                    ...notification,
                    RequestedResources: notification.RequestedResources,
                    ActualArrival: actualArrival,
                    EstimatedArrival: DateTime.fromISO(
                        this.notification.EstimatedArrival.toISOString()
                    ).toFormat(dateTimeFormat),
                }
            )
            this.$emit('notification-update', notification.RequestedResources)
        },

        removePackage(blcPackage) {
            let index = this.packageGroups.indexOf(blcPackage)
            this.packageGroups.splice(index, 1)
        },

        async deletePackage(blcPackage) {
            try {
                await this.$confirm(
                    this.$i18n.i18next.t('message.warning.delete', {
                        section: 'package',
                    }),
                    'Warning',
                    {
                        confirmButtonText: this.$i18n.i18next.t(
                            'button.text.confirm'
                        ),
                        cancelButtonText:
                            this.$i18n.i18next.t('button.text.cancel'),
                        type: 'warning',
                    }
                )

                this.removePackage(blcPackage)

                if (blcPackage.PackageGroupID) {
                    await this.$http.delete(
                        `/BLC/${this.container.ContainerID}/Notification/${this.notification.BLCNotificationID}/PackageGroup/${blcPackage.PackageGroupID}`
                    )
                    this.$emit('package-delete', blcPackage)
                }
            } catch (e) {
                if (e === 'cancel') {
                    //
                } else {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: this.$i18n.i18next.t('message.error.general'),
                    })
                }
            }
        },
    },
}
</script>
